// extracted by mini-css-extract-plugin
export default {"container":"kA2s2rPv5kWQ9fI_4Ulm","header":"H__fuR9xw5oqRfqlUhRQ","list":"HZADgq0S6l0rQrEJEls9","alert":"Iq_awhxmrDuUqfoIC1Th"};